export const PLAN = 'plan';
export const OFFER = 'offer';
export const COMEMBERSHIP = 'co-membership';
export const ALLOW_PREPAID_CARDS_PLANS = ['CAN_TORONTO_STACK30CREDITCORPORATEPLAN_5800_5_3X_30CREDIT'];
